

export function categoryUrl({id, name}) {
  return `/gallery/${id}/${name.replaceAll("/", "|").replaceAll(" ", "_")}`
}